












































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSTable from '@/components/AMSTable.vue';
import AMSProductSelector from '@/components/AMSProductSelector.vue';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import request from '@/utils/request';
import { emptyRule, selectEmptyRule } from '@/utils/rules';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';

import { allStaff } from '@/api/staff';
import { getInstock, createOrEditInstock, getStockWarehouses } from '@/api/stock';
import Utils from '@/utils/utils';
interface Product {
  productId?: string;
  quantity?: number;
}
interface Form {
  number?: string;
  operatorId?: Number;
  warehouseId?: string;
  type?: 'PurchaseReturn' | 'TransferOut' | 'Loss' | 'OtherOut';
  stockTime?: string;
  products?: Product[];
  remark?: string;
  id?: string;
  category?: 'Out';
}

@Component({
  components: {
    'ams-table': AMSTable,
    'ams-product-selector': AMSProductSelector,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class EditOutStock extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: '/outStock'
    },
    {
      text: '出库单',
      disabled: false,
      href: '/outStock'
    },
    {
      text: this.isEdit() ? '修改出库单' : '新增出库单',
      disabled: true
    }
  ];
  staffList: Array<any> = [];
  WarehousesList: Array<any> = [];
  typeList = [
    { value: 'PurchaseReturn', text: '采购退货' },
    // { value: 'Order', text: '销售出库' },
    { value: 'TransferOut', text: '调拨出库' },
    { value: 'Loss', text: '盘亏出库' },
    { value: 'OtherOut', text: '其他出库' }
  ];
  form: Form = {
    stockTime: new Date().toISOString().substr(0, 10),
    type: 'Loss',
    category: 'Out'
  };
  rules = {
    operatorId: [selectEmptyRule('经办人')]
  };
  headers = [
    { text: '序号', value: 'number', isSort: true, sortable: false },
    {
      text: '商品',
      value: 'name',
      render: (h: Function, param: any) => {
        return h(AMSSelectedProduct, {
          props: {
            items: param,
            selectedItems: this.products,
            isMoreBtn: true
          },
          on: {
            select: (value: Array<object>) => {
              this.products.splice(param.index, 1, ...value);
            },
            autoComplete: (value: Object) => {
              this.products.splice(param.index, 1, value);
            }
          }
        });
      },
      sortable: false
    },
    { text: '容量', value: 'capacity', sortable: false },
    {
      text: '出库数量',
      value: 'quantity',
      // edit: true,
      sortable: false,
      isInputNumber: {
        type: 'stockQuantity'
      }
    },
    {
      text: '限用日期',
      value: 'productionDate',
      isDatePicker: true
    },
    {
      text: '操作',
      value: 'actions',
      isActions: true,
      align: 'center',
      sortable: false
    }
  ];
  products: Array<Object> = [{}];
  maxDate = new Date().toISOString().substr(0, 10);
  date = new Date().toISOString().substr(0, 10);
  stockTime: boolean = false;
  addloading: Boolean = false;
  isSaving = false;
  valid = false;
  isEdit() {
    return this.$route.query.isEdit;
  }
  plus(a: number, b: number) {
    return a + b;
  }

  get totalProducts() {
    return this.products.filter((p: any) => {
      return p.id;
    }).length;
  }
  get totalQuantity(): number {
    return this.products
      .map((item: any) => {
        return parseInt(item.quantity);
      })
      .filter((f: any) => {
        return f;
      })
      .reduce(this.plus, 0);
  }
  get isNoProduct() {
    let filters = this.products.filter((p: any) => {
      return p.id;
    });
    return filters.length == 0;
  }
  get isNoQuantity() {
    let error = false;
    this.products.forEach((p: any) => {
      if (p.id && !p.quantity) {
        error = true;
      }
    });
    return error;
  }

  created() {
    this.getStockWarehousesList();
    this.getStaff();
    this.getFormData();
  }

  getFormData() {
    if (!this.$route.query.id) return;
    // OUTSTOCK
    getInstock(this.$route.query.id.toString()).then((data: any) => {
      this.form = Object.assign({}, this.form, data);
      var products = data.products.map((p: any) => {
        return Object.assign({}, p, { productionDate: p.productionDate ? moment(p.productionDate).format('YYYY-MM-DD') : null });
      });
      this.products.splice(0, 1, ...products);
      this.form.stockTime = moment(data.stockTime).format('YYYY-MM-DD');
    });
  }
  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
      if (!this.$route.query.id) {
        this.form.operatorId = this.$store.state.user.staffId;
      }
    });
  }
  getStockWarehousesList() {
    getStockWarehouses().then((data: any) => {
      this.WarehousesList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
      this.form.warehouseId = this.WarehousesList[0].id;
    });
  }
  add(index: number, key: string) {
    this.products.splice(index + 1, 0, {});
  }
  remove(index: number, key: string) {
    this.products.splice(index, 1);
    if (this.products.length < 1) {
      this.products.push({});
    }
  }
  textChange(list: Array<object>) {
    this.products = list;
  }
  back() {
    this.$router.go(-1);
  }
  save() {
    if (this.isNoProduct) {
      AppStore.ShowError(`请选择商品`);
      return;
    }
    if (this.isNoQuantity) {
      AppStore.ShowError(`出库数量不能为空`);
      return;
    }
    if (!this.isNoQuantity && !this.isNoProduct) {
      this.isSaving = true;
      this.addloading = true;
      let formData = Object.assign({}, this.form, {
        products: this.products
          .filter((f: any) => f.id)
          .map((p: any) => {
            return { productId: p.id, quantity: p.quantity, productionDate: p.productionDate };
          })
      });
      // OUTSTOCK
      createOrEditInstock(formData)
        .then((data: any) => {
          this.addloading = false;
          this.$router.push({ name: 'outStock' });
          Utils.clearAllSearchPage(this.$route.name as string);
        })
        .catch((err: any) => {})
        .finally(() => {
          Utils.clearAllSearchPage(this.$route.name as string);
          this.addloading = false;
          this.isSaving = false;
        });
    }
  }
}
